// extracted by mini-css-extract-plugin
module.exports = {"phoneNumber":"index_phoneNumber__X80CM","countryCode":"index_countryCode__QjiiJ"};